import { CILogger } from 'common/log/log.provider';

import type { ForgotCredentialsState } from './types';

const FORGOT_CREDENTIALS_STORAGE_KEY = 'ciForgotCredentials';

export const EMPTY_FORGOT_CREDENTIALS: ForgotCredentialsState = {
    username: null,
    securityQuestions: null,
    activationCode: null,
    activationTargetUsername: null,
};

function isEmptyForgotCredentials(state: ForgotCredentialsState): boolean {
    return !state.username && !state.securityQuestions && !state.activationCode && !state.activationTargetUsername;
}

export function readPersistedForgotCredentials(): ForgotCredentialsState {
    const persisted = sessionStorage.getItem(FORGOT_CREDENTIALS_STORAGE_KEY);

    if (!persisted) {
        return EMPTY_FORGOT_CREDENTIALS;
    }

    try {
        return { ...EMPTY_FORGOT_CREDENTIALS, ...(JSON.parse(persisted) as ForgotCredentialsState) };
    } catch (error) {
        CILogger.getInstance().error('forgot credentials: failed to parse persisted state', error);

        return EMPTY_FORGOT_CREDENTIALS;
    }
}

export function persistForgotCredentials(state: ForgotCredentialsState): void {
    if (isEmptyForgotCredentials(state)) {
        clearForgotCredentials();

        return;
    }

    sessionStorage.setItem(FORGOT_CREDENTIALS_STORAGE_KEY, JSON.stringify(state));
}

export function clearForgotCredentials(): void {
    sessionStorage.removeItem(FORGOT_CREDENTIALS_STORAGE_KEY);
}
